<template>
  <div class="animated fadeIn">
    <template v-if="collection.length">
      <irrigation-form
        v-for="(submission, index) in collection"
        :key="index"
        :submission="submission"
        :testPackageSamples="testPackageSamples"
        :addOns="addOns"
        :turnArounds="
          sampleType && sampleType.getTurnarounds()
            ? sampleType.getTurnarounds()
            : null
        "
        :serviceQuestions="
          sampleType && sampleType.getServiceQuestions()
            ? sampleType.getServiceQuestions()
            : null
        "
        :index="index"
        :textureOptions="texture_options"
        :horizonOptions="horizon_options"
        @onSubmissionChange="onSubmissionChange"
        @removeSubmission="removeSubmission"
      ></irrigation-form>
    </template>
    <div class="clearfix">
      <b-button class="float-right" variant="success" @click="newSubmission"
        ><i class="fal fa-plus"></i> Add submission</b-button
      >
    </div>
  </div>
</template>
<script>
import IrrigationForm from "./form/IrrigationForm";
import Submission from "../../../models/legacy/Submission";
import TestPackageSampleCollection from "../../../collections/lab/TestPackageSampleCollection";
import TestPackageCollection from "../../../collections/lab/TestPackageCollection";

export default {
  name: "IrrigationSubmissionForm",
  components: {
    IrrigationForm
  },
  props: {
    submissions: {
      type: Array,
      default: () => []
    },
    testPackageSamples: {
      type: Object,
      default: () => new TestPackageSampleCollection()
    },
    testPackage: {
      type: Object,
      default: () => null
    },
    sampleType: {
      type: Object,
      default: () => null
    },
    managedLists: {
      type: Array,
      default: () => []
    },
    addOns: {
      type: Object,
      default: () => new TestPackageCollection()
    }
  },
  data() {
    return {
      collection: [],
      texture_options: {},
      horizon_options: {}
    };
  },
  methods: {
    createOptionList(list, field) {
      return {
        options: list.map(item => {
          return { id: item.id, name: item.value };
        }),
        field
      };
    },
    filterOptionList() {
      this.texture_options = this.createOptionList(
        this.managedLists.find(
          item =>
            item.sub_type === "irrigation_suitability" &&
            item.list === "texture"
        ).attribute_lists,
        "field_texture"
      );
      this.horizon_options = this.createOptionList(
        this.managedLists.find(
          item =>
            item.sub_type === "irrigation_suitability" &&
            item.list === "horizon"
        ).attribute_lists,
        "soil_horizon"
      );
    },
    newSubmission() {
      this.collection = [...this.collection, this.fillSubmission({})];
    },
    fillSubmission(data) {
      data = data || {};
      data = JSON.parse(JSON.stringify(data));
      data.sample_type = this.sampleType
        ? JSON.parse(JSON.stringify(this.sampleType))
        : null;
      data.test_package = this.testPackage
        ? JSON.parse(JSON.stringify(this.testPackage))
        : null;
      const new_bore_hole_id = this.$uuid.v4();
      const default_sample_list = Array(3).fill({
        identifier: null,
        test_package_sample_id: null,
        sample_irrigation_suitability: {
          number: null,
          bore_hole_id: new_bore_hole_id,
          depth_end: null,
          depth_start: null,
          field_texture: null,
          soil_horizon: null
        }
      });
      data.bore_holes = data.bore_holes || [
        {
          bore_hole_id: data.bore_hole_id || new_bore_hole_id,
          identifier: data.identifier || null,
          field_texture: data.field_texture || null,
          soil_horizon: data.soil_horizon || null,
          samples: default_sample_list.map((sample, index) => {
            let start = +index * 6;
            return {
              ...sample,
              identifier: `Sample ${+index + 1}`,
              test_package_sample_id: this.$uuid.v4(),
              sample_irrigation_suitability: {
                ...sample.sample_irrigation_suitability,
                number: index + 1,
                depth_end: start + 6,
                depth_start: start
              }
            };
          })
        }
      ];
      data.samples = [];
      data.bore_holes.forEach(bore_hole => {
        data.samples = [...data.samples, ...bore_hole.samples];
      });

      if (this.$cookies.get("faker_enabled") === "1") {
        data.identifier = data.identifier || this.$faker().name.lastName();
        data.event_code =
          data.event_code ||
          data.identifier.replace(/\W/g, "").toUpperCase() +
            "-" +
            new Date().getUTCMilliseconds();
        data.bore_holes = data.bore_holes || {};
      }
      return new Submission(data);
    },
    onSubmissionChange(params) {
      if (params && params.submission && params.index !== null) {
        this.collection.splice(
          params.index,
          1,
          this.fillSubmission(params.submission)
        );
        this.onSubmissionsChange();
      }
    },
    onSubmissionsChange() {
      this.$emit("onSubmissionsChange", this.collection);
    },
    removeSubmission(index) {
      if (index !== null) {
        this.collection.splice(index, 1);
      }
    }
  },
  mounted() {
    this.filterOptionList();
    if (!this.submissions.length) {
      this.newSubmission();
    } else {
      this.submissions.forEach(submission => {
        this.collection = [...this.collection, this.fillSubmission(submission)];
      });
    }
  }
};
</script>
